import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ErrorData } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import * as ProductDetailActions from '../../store/product-detail-actions';
import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { ProductVariant } from '../models/product-detail-variant';
import { ReduxDispatch } from '../../../../../../store/use-thunk-dispatch';

export const PRODUCT_DETAIL_VARIANTS_ADDED = 'PRODUCT_DETAIL_VARIANTS_ADDED';
export const PRODUCT_DETAIL_VARIANTS_ERROR = 'PRODUCT_DETAIL_VARIANTS_ERROR';
export const PRODUCT_DETAIL_VARIANTS_FETCH = 'PRODUCT_DETAIL_VARIANTS_FETCH';
export const PRODUCT_DETAIL_VARIANTS_RECEIVE = 'PRODUCT_DETAIL_VARIANTS_RECEIVE';
export const PRODUCT_DETAIL_VARIANTS_REMOVED = 'PRODUCT_DETAIL_VARIANTS_REMOVED';
export const PRODUCT_DETAIL_VARIANTS_SAVE = 'PRODUCT_DETAIL_VARIANTS_SAVE';
export const PRODUCT_DETAIL_VARIANTS_STATUS_CHANGE = 'PRODUCT_DETAIL_VARIANTS_STATUS_CHANGE';
export const PRODUCT_DETAIL_VARIANTS_UNLINK = 'PRODUCT_DETAIL_VARIANT_UNLINK';

const error = (errorData?: ErrorData) => ({
    type: PRODUCT_DETAIL_VARIANTS_ERROR,
    errorData,
});

const receiveVariants = (variants: ProductVariant[]) => ({
    type: PRODUCT_DETAIL_VARIANTS_RECEIVE,
    variants,
});

const removeProductVariant = (productId: number) => {
    return {
        type: PRODUCT_DETAIL_VARIANTS_REMOVED,
        productId,
    };
};

export const deleteProductVariant = (productId: number) => {
    return (dispatch: ReduxDispatch) => {
        dispatch(ProductDetailActions.deleteProduct(productId));

        dispatch(removeProductVariant(productId));
    };
};

const productVariantAdded = (variant: ProductVariant) => {
    return {
        type: PRODUCT_DETAIL_VARIANTS_ADDED,
        variant,
    };
};

const changeVariantStatus = (status: boolean, variantId: number) => {
    return {
        type: PRODUCT_DETAIL_VARIANTS_STATUS_CHANGE,
        variantId,
        status,
    };
};

export const saveProductVariant = (variant: ProductVariant) => {
    return async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_VARIANTS_SAVE });

        const productId = getState().product.detail.overview.productDetail?.id;
        if (!productId || !variant) {
            return;
        }

        const response = await api.product.detail.variants.addVariant(productId, variant);
        if (response.success) {
            dispatch(productVariantAdded(variant));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.variantAdded')));
        } else {
            dispatch(error(response.error));
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchProductVariants = () => {
    return async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_VARIANTS_FETCH });
        const productId = getState().product.detail.overview.productDetail?.id;
        if (!productId) {
            return;
        }

        const response = await api.product.detail.variants.getVariants(productId);
        if (response.success) {
            dispatch(receiveVariants(response.result));
        } else {
            dispatch(error(response.error));
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const activateProductVariant = (variantId: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.product.detail.activate(variantId);

        if (response.success) {
            dispatch(changeVariantStatus(true, variantId));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.articleActivated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deactivateProductVariant = (variantId: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.product.detail.deactivate(variantId);

        if (response.success) {
            dispatch(changeVariantStatus(false, variantId));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.articleDeactivated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const unlinkProduct = (productId: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_VARIANTS_UNLINK });

        const response = await api.product.detail.variants.removeVariant(productId);
        if (response.success) {
            dispatch(removeProductVariant(productId));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.variantRemoved')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
